import styled from '@emotion/styled'

export const Container = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 70% 30%;
  grid-column-gap: 5px;
  grid-row-gap: 10px;
`
